import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        padding: FOUNDATIONS.spacing_250,
        border_radius: FOUNDATIONS.radius_250,
        background_color: FOUNDATIONS.color_comp_containers_accordion_neutral_bg,
    },
    trigger: {
        cursor: 'pointer',
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        padding_right: FOUNDATIONS.spacing_150,
        flex: 1,
        gap: FOUNDATIONS.spacing_150,
    },
    triggerIconContainer: {
        align_items: 'center',
        display: 'flex',
        justify_content: 'center',
        transform: 'rotate(0deg)',
        transition: 'transform 0.15s ease-in-out',
        align_self: 'start',
    },
    triggerIcon: {
        color: FOUNDATIONS.color_comp_containers_accordion_icon,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    title: {
        display: 'flex',
        text_align: 'left',
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_containers_accordion_font,
    },
    content: {
        padding_top: FOUNDATIONS.spacing_150,
    },
    headerMainContainer: {
        width: '100%',
        display: 'flex',
        align_items: 'center',
        justify_content: 'space-between',
    },
    headerDescriptionContainer: {
        display: 'flex',
        flex: '1',
        justify_content: 'flex-end',
    },
    headerDescription: {
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_comp_containers_accordion_font,
        word_break: 'break-word',
    },
    headerRightContentContainer: {
        align_self: 'center',
    },
    titleHeaderMainContainer: {
        flex: '1',
    },
    subHeader: {
        margin_top: FOUNDATIONS.spacing_150,
    },
});
//# sourceMappingURL=commonStyles.js.map